let apiKey = '';
let fullCalendarLicenseKey = '';

try {
  apiKey = process.env.GOOGLE_API_KEY;
} catch (e) {
  console.error(e);
  console.error('apiKey is empty');
}

try {
  fullCalendarLicenseKey = process.env.FULL_CALENDAR_KEY;
} catch (e) {
  console.error(e);
  console.error('fullCalendarKey is empty');
}

export const environment = {
  production: true,
  logErrors: false,
  fullCalendarLicenseKey,
  googleApi: {
    apiKey,
    libraries: ['places'],
    language: 'en',
    protocol: 2,
  },
};
